import React, { useRef } from "react";
import { Line } from "react-chartjs-2";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
const utahData = "/img/1.png";
const kpi = "/img/KPI-DASH 2.png";
const bodex = "/img/bodexLogo.png";
const pdf = "/img/pdf1.png";

const EngTable2 = ({ data }) => {
  const pdfRef = useRef();
  const chartData = {
    labels: data.map((item) => item.year),
    datasets: [
      {
        label: "Gender Gap",
        data: data.map((item) => parseInt(item.male - item.female)),
        borderColor: "blue",
        backgroundColor: "rgba(173, 216, 230, 0.5)",
        borderWidth: 3,
        tension: 0.4, // Smooth curve
        pointBackgroundColor: "white",
        pointBorderColor: "blue",
        pointBorderWidth: 2,
        pointRadius: 5, // Larger points for visibility
        pointHoverRadius: 7, // Increase point size on hover
        pointHoverBackgroundColor: "blue",
        fill: true,
      },
      // {
      //   label: "Female Employment",
      //   data: data.map((item) => parseInt(item.female)),
      //   borderColor: "pink",
      //   backgroundColor: "rgba(255, 192, 203, 0.5)",
      //   borderWidth: 3,
      //   tension: 0.4, // Smooth curve
      //   pointBackgroundColor: "white",
      //   pointBorderColor: "pink",
      //   pointBorderWidth: 2,
      //   pointRadius: 5, // Larger points for visibility
      //   pointHoverRadius: 7, // Increase point size on hover
      //   pointHoverBackgroundColor: "pink",
      //   fill: true,
      // },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        labels: {
          font: {
            size: 14,
          },
        },
      },
      title: {
        display: true,
        text: "Yearly Employment by Gender",
        font: {
          size: 18,
        },
      },
    },
    elements: {
      line: {
        borderJoinStyle: "round", // Smooth line join
      },
    },
  };

  const downloadPDF = () => {
    const input = pdfRef.current;

    const originalWidth = input.style.width;
    input.style.width = "1100px";
    html2canvas(input, { scale: 3 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(utahData, "PNG", 60, 4, 30, 30);
      pdf.setFontSize(26);
      pdf.text("UTahData.org", 95, 22);

      pdf.link(50, 15, 60, 10, { url: "https://utahdata.org" });

      const currentDate = new Date();
      const formattedDate = currentDate.toLocaleDateString();
      pdf.setFontSize(12);
      pdf.text(`Downloaded on: ${formattedDate}`, 150, 295);

      pdf.setLineWidth(0.5);
      pdf.setDrawColor(0, 0, 0);
      pdf.line(10, 35, 200, 35);

      const headerHeight = 38;
      pdf.addImage(imgData, "PNG", 0, headerHeight, imgWidth, imgHeight);

      pdf.line(10, 260, 200, 260);

      const footerStartY = 265;
      pdf.addImage(utahData, "PNG", 33, footerStartY, 20, 20);
      pdf.setFontSize(10);
      pdf.setTextColor(0, 122, 255);
      pdf.text("Built by", 55, footerStartY + 10);

      pdf.addImage(bodex, "PNG", 68, footerStartY + 4, 44, 10);
      pdf.text("using", 112, footerStartY + 10);
      pdf.addImage(kpi, "PNG", 125, footerStartY, 20, 20);

      pdf.text(" 20250916.v3.198", 148, footerStartY + 10);

      const currentURL = window.location.href;
      pdf.text(`Downloaded from: ${currentURL}`, 10, 295);

      pdf.save("eng_table1.pdf");
      input.style.width = originalWidth;
    });
  };

  return (
    <>
      <div className="dashboard-container">
        <div ref={pdfRef} className="content-to-export">
          <div style={{ padding: "20px" }}>
            <h2>Gender Gap (Male - Female) Yearwise</h2>

            {/* Render Table with Horizontal Scrolling */}
            <div className="overflow-x-auto">
              <table className="table table-striped bg-white">
                <thead>
                  <th>Year</th>
                  <th>Male</th>
                  <th>Female</th>
                  <th>Gender Gap</th>
                </thead>
                <tbody>
                  {data.map((row, index) => (
                    <tr key={index}>
                      <td>{row.year}</td>
                      <td>{row.male}</td>
                      <td>{row.female}</td>
                      <td>{row.male - row.female}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* Bar Chart Section */}
            <div
              style={{
                width: "90%",
                maxWidth: "800px",
                margin: "auto",
                overflowX: "auto",
              }}
            >
              <div
                style={{
                  width: "100%",
                  minWidth: "600px",
                  //height: "400px",
                  background:"#fff"
                }}
              >
                <Line data={chartData} options={options} />
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center">
          <button
            onClick={downloadPDF}
            className="download-btn bg-red-800 hover:bg-red-950 p-2 text-white rounded-lg flex items-center justify-between"
          >
            <span>Download as PDF </span>
            <span>
              <img className="w-[2rem]" src={pdf} />
            </span>
          </button>
        </div>
      </div>
    </>
  );
};

export default EngTable2;
